import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { GetRepresentationIdDTO, RepresentStatusUpdateDto } from './dto/reprentation.dto';
import { AllRepresentationResponseModel, RepresentationResponseModel } from './representation-response-module';
import { RepresentationEntity } from './representation.entity';

@Injectable()
export class RepresentationService {


    constructor (
        @InjectRepository(RepresentationEntity)
        private representationRepository: Repository<RepresentationEntity>, 
       
         
    ) {}    
    

    async createrepresentation(queryParams, filesData, ): Promise<RepresentationResponseModel> {
        const response = new RepresentationResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const fileUpload = await this.representationRepository.save(filesData);
                if(fileUpload) {
                    response.status = true;
                    response.data   = fileUpload;
                    response.statusCode = 50000;
                    response.internalMessage = 'representation saved successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Add not saved')
                }
            } else {
                const fileUpload = await this.representationRepository.save(filesData);
                if(fileUpload) {
                    response.status = true;
                    response.data   = fileUpload;
                    response.statusCode = 50000;
                    response.internalMessage = 'representation saved successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Add not saved')
                }
            }            
            return response;
        } catch (error) {
            throw error;
        }
    }

    async updateRepresentation(queryParams, filesData, ): Promise<RepresentationResponseModel> {
        const response = new RepresentationResponseModel();
        console.log(filesData)
        filesData = JSON.parse(JSON.stringify(filesData[0]));
        console.log(filesData,"80")
        try {
            if(queryParams.apiVersion == 1) {
                const fileUpload = await this.representationRepository.update(filesData.Id,filesData);
                const data = await this.representationRepository.findOne({

                    where: {Id:filesData.Id,status: true},
                });
                if(fileUpload) {
                    response.status = true;
                    response.data= data;
                    response.statusCode = 50000;
                    response.internalMessage = 'representation updated successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Add not saved')
                }
            } else {
                const fileUpload = await this.representationRepository.update(filesData.Id,filesData);
                const data = await this.representationRepository.findOne({

                    where: {Id:filesData.Id,status: true},
                });
                if(fileUpload) {
                    response.status = true;
                    response.data= data;
                    response.statusCode = 50000;
                    response.internalMessage = 'representation updated successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Add not saved')
                }
            }            
            return response;
        } catch (error) {
            throw error;
        }
    }
	
    async getAllActiverepresentation(queryParams,request:Request):Promise<AllRepresentationResponseModel> {
        const response = new AllRepresentationResponseModel();
        try {
            let images: any[] = [];
            let pdfs: any[] = [];
            if(queryParams.apiVersion == 1) {
            const data = await this.representationRepository.find({
                where: {status: true},
                order: { createdAt: 'DESC' }
            });
			if (data.length != 0) {
				const da = data.map((file) => {
					return {
						Id: file.Id,
                        firstName: file.firstName,
                        lastName: file.lastName,
                        mobileNo: file.mobileNo,
                        email: file.email,
                        location: file.location,
						attachmentsUrl: `${process.env.WORKINGURL}/${file.attachmentsUrl}`,						
                    };                   
                });
               da.map((file) => {
                    images.push({Id: file.Id,firstName: file.firstName,lastName: file.lastName,mobileNo: file.mobileNo,email: file.email, attachmentsUrl: file.attachmentsUrl,location:file.location })
                });				
            }
            if(data) {
                response.status = true;
                response.data = images;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        }
        else{
            const data = await this.representationRepository.find({
                where: {status: true},
                order: { createdAt: 'DESC' }
            });
			if (data.length != 0) {
				const da = data.map((file) => {
					return {
						Id: file.Id,
                        firstName: file.firstName,
                        lastName: file.lastName,
                        mobileNo: file.mobileNo,
                        email: file.email,
                        location: file.location,
						attachmentsUrl: `${process.env.WORKINGURL}/${file.attachmentsUrl}`,						
                    };                   
                });
               da.map((file) => {
                    images.push({Id: file.Id,firstName: file.firstName,lastName: file.lastName,mobileNo: file.mobileNo,email: file.email, attachmentsUrl: file.attachmentsUrl,location:file.location })
                });				
            }
            if(data) {
                response.status = true;
                response.data = images;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        }
            return response;
        } catch (error) {
            throw error;
        }
    }


    async getActiverepresentation(queryParams,GetRepresentationIdDTO:GetRepresentationIdDTO,request:Request):Promise<AllRepresentationResponseModel> {
        const response = new AllRepresentationResponseModel();
        try {
            let images: any[] = [];
            let pdfs: any[] = [];
            if(queryParams.apiVersion == 1) {
            const data = await this.representationRepository.find({

                where: {Id:GetRepresentationIdDTO.Id,status: true},
            });
			if (data.length != 0) {
				const da = data.map((file) => {
					return {
						Id: file.Id,
                        firstName: file.firstName,
                        lastName: file.lastName,
                        mobileNo: file.mobileNo,
                        email: file.email,
                        location: file.location,
						attachmentsUrl: `${process.env.WORKINGURL}/${file.attachmentsUrl}`,						
                    };                   
                });
               da.map((file) => {
                    images.push({Id: file.Id,firstName: file.firstName,lastName: file.lastName,mobileNo: file.mobileNo,email: file.email, attachmentsUrl: file.attachmentsUrl,location:file.location })
                });				
            }
            if(data) {
                response.status = true;
                response.data = images;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        }
        else{
            const data = await this.representationRepository.find({

                where: {Id:GetRepresentationIdDTO.Id,status: true},
                order: { createdAt: 'DESC' }
            });
			if (data.length != 0) {
				const da = data.map((file) => {
					return {
						Id: file.Id,
                        firstName: file.firstName,
                        lastName: file.lastName,
                        mobileNo: file.mobileNo,
                        email: file.email,
                        location: file.location,
						attachmentsUrl: `${process.env.WORKINGURL}/${file.attachmentsUrl}`,						
                    };                   
                });
               da.map((file) => {
                    images.push({Id: file.Id,firstName: file.firstName,lastName: file.lastName,mobileNo: file.mobileNo,email: file.email, attachmentsUrl: file.attachmentsUrl,location:file.location })
                });				
            }
            if(data) {
                response.status = true;
                response.data = images;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        }
            return response;
        } catch (error) {
            throw error;
        }
    }
    async updateRepresentStatus(queryParams,RepresentStatusUpdateDto:RepresentStatusUpdateDto, request:Request):Promise<RepresentationResponseModel> {
        const response = new RepresentationResponseModel();
        try {
            const updateRole = await this.representationRepository.update(RepresentStatusUpdateDto.Id, RepresentStatusUpdateDto);
            const updatedData = await this.representationRepository.findOne({
                where:{Id:RepresentStatusUpdateDto.Id}
            });
            if(updateRole) {
                response.status = true;
                response.data   = updatedData;
                response.statusCode = 50000;
                response.internalMessage = 'Role Status updated successfully';
                response.intlCode = 11108;
            } else {
                throw new ErrorResponse(99998, 'Role Status update failed')
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

}
